import { XMarkIcon } from '@heroicons/react/24/outline'
import { useLayoutEffect, useRef } from 'react'

const Modal = ({ isOpen, onClose, children, styleClass = '' }) => {
  const dialogRef = useRef()

  useLayoutEffect(() => {
    if (isOpen) {
      dialogRef.current.showModal()
    } else {
      dialogRef.current.close()
    }
  }, [isOpen])

  return (
    <dialog
      onClose={onClose}
      ref={dialogRef}
      className={`fixed bg-background rounded-lg shadow-xl w-min min-w-full md:min-w-[400px] lg:min-w-[500px]  p-4 m-0 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 ${styleClass}`}
    >
      <XMarkIcon
        className="w-8 h-8 text-gray-600 cursor-pointer absolute right-2 top-2"
        onClick={onClose}
      />
      <div className="mt-4">{children}</div>
    </dialog>
  )
}

export default Modal
